import axios from 'axios';
import { merge } from 'lodash';
import { toast } from 'react-toastify';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import userACL from '../../../store/access';
import { getHeaderJWT, URL } from '../../../store/path';
import { handlError, parseError } from '../../app/serverError';
import { fetchedVtype, savedVtype, saveVtypeEditedRes } from './actions';


// const delay = (ms) => new Promise(res => setTimeout(res, ms))


//#region Saga for Edit Vtype 

function* editVtype() {
  yield takeEvery('EDIT_VTYPE', saveEditedVtype)
}

function* saveEditedVtype(action) {

  const { response, error } = yield call(editVtypeAPI, action.payload)

  if (response) {
    yield put(savedVtype(action.payload))
    yield put(saveVtypeEditedRes(action.payload))
  }

  else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

function editVtypeAPI(data) {
  let obj = {
    id: data.id,
    status: data.status,
    app_only_4_loc_cd_lst: data.app_only_4_loc_cd_lst || ""
  }
  return axios.post(URL + '/master/vtype/update', obj, getHeaderJWT(), { crossDomain: true })
    .then(response => ({ response }))
    .catch(error => ({ error }))

}

//#endregion


//#region Saga for updating the applicable LOC code list of a vtype

function* updateVtypeLoc() {
  yield takeEvery('UPDATE_VTYPE_LOC', saveVtypeLoc)
}

function* saveVtypeLoc(action) {
  // Optimistic UI update so the dropdown reflects the change immediately
  yield put(savedVtype(action.payload))
  const { response, error } = yield call(updateVtypeLocAPI, action.payload)
  if (response) {
    toast.success("Saved", { position: "top-right", autoClose: 1500, hideProgressBar: true })
  } else {
    yield put(handlError(action, parseError(error)))
    toast.error("Failed to save LOC CD", { position: "top-right", autoClose: 2500, hideProgressBar: true })
    sagaErrorMessage(error, action)
  }
}

function updateVtypeLocAPI(data) {
  let obj = {
    id: data.id,
    status: data.status,
    app_only_4_loc_cd_lst: data.app_only_4_loc_cd_lst || ""
  }
  return axios.post(URL + '/master/vtype/update', obj, getHeaderJWT(), { crossDomain: true })
    .then(response => ({ response }))
    .catch(error => ({ error }))
}

//#endregion


//#region Saga for List Vtype 

function* fetchVtype() {
  yield takeEvery('FETCH_VTYPE', requestVtype)
}


function* requestVtype() {
    let { data } = yield call(requestVtypeAPI)
    yield put(fetchedVtype(data))
}


function requestVtypeAPI(data) {
  data = merge({}, data, userACL.atFetch())
  return axios.post(URL + '/master/vtype/list', data, getHeaderJWT(), { crossDomain: true })
}

//#endregion



const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type)
  console.log(error)
  console.groupEnd()
}

export default function* vtypeSaga() {
  yield all([
    fetchVtype(),
    editVtype(),
    updateVtypeLoc(),
  ])
}  